const flagConfig = {
  host: process.env.REACT_APP_FLAGS_CTX_HOST,
  uri: process.env.REACT_APP_FLAGS_CTX_URI,
  instanceId: process.env.REACT_APP_FLAGS_CTX_INSTANCE_ID,
  appName: process.env.REACT_APP_FLAGS_CTX_NAME,
};

export default flagConfig;
